export enum MiPlatformSignalREventNames {
  UserUpdated = "UserUpdateEvent",
  AttemptUpdated = "AttemptUpdated",
}
